/* eslint-disable react-hooks/rules-of-hooks */
import {useQuery} from "react-query";
import {SERVICE_API_URL} from "../utils/constants";
import {requestWithToken} from "../utils/functions";

export async function createTeammate(payload: any, customer_email: string) {
    const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/${customer_email}/teammates`, 'POST', payload)

    return response?.data?.data?.teammates
}


export function resolveInvitationDetail(id: string | (string | null)[] | null) {
    return useQuery(["team.invitation.detail", id], async () => {
        const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/${id}`)

        return response?.data?.data?.team
    }, {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        retry: false,
        staleTime: 30 * 1000,
        enabled: typeof id !== "undefined",
        suspense: true
    })
}

export function resolveInvitationToken(token: string | (string | null)[] | null) {
    return useQuery(["team.invitation.token", token], async () => {
        const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/invitation/validate`, 'POST', {token})

        return response?.data?.data
    }, {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        retry: false,
        staleTime: 30 * 1000,
        enabled: typeof token !== "undefined",
        suspense: true
    })
}

export async function joinTeam(payload: any) {
    const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/invitation/join`, 'POST', payload)

    return response?.data
}

export async function acceptInvitation(payload: any) {
    const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/invitation/accepted`, 'POST', payload)

    return response?.data?.data
}

export function resolveInvitedTeam({email}: any) {
    return useQuery(["user.team.invited", email], async () => {
        const response = await requestWithToken(`${SERVICE_API_URL}/v2/teammates/${email}/teams`)

        return response?.data?.data
    }, {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        retry: false,
        staleTime: 30 * 1000,
        enabled: typeof localStorage.getItem('SA') !== "undefined",
        suspense: true
    })
}

export function resolveTeamPermissions() {
    return useQuery(["customer.team.permissions"], async () => {
        try {
            const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/shares_n_permissions`)

            return response?.data?.data?.permissions
        } catch (exception) {
            console.log(exception)
        }
    }, {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        retry: false,
        staleTime: 30 * 1000,
        suspense: true
    })
}